import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as chartJs from './chart-js'
import * as sunburst from './sunburst'

@ngCore.Component({
  imports: [chartJs.Component, sunburst.Component],
  selector: 'atn-ds-chart',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Makes {@link ents.core.display.chart.Type} available to the HTML
   */
  public readonly ChartType = ents.core.display.chart.Type

  /**
   * {@link ents.core.display.chart.Chart} being displayed
   */
  public chartSg = ngCore.input.required<ents.core.display.chart.Chart>({
    alias: 'chart',
  })
}
